import { infiniteQueryOptions, queryOptions } from "@tanstack/react-query";
import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";
import buildUrlWithParams from "./buildUrlWithParams";

const PAGE_SIZE = 100;

const noteDataInfoQueryOptions = (params: {
  skip?: number;
  limit?: number;
  patientCognitoSub?: string;
  noteDataId?: number[];
  practiceGroup?: boolean;
}) => {
  return queryOptions({
    queryKey: ["noteDataInfo", params],
    queryFn: async ({ signal }) => {
      const url = buildUrlWithParams(
        "/api/notes_secure_data/v1/notes/data/data_info",
        params,
      );

      const res = await fetchOrchidAPI(url, { signal });
      if (!res.ok) {
        throw new Error(
          `failed to query note data info: ${getErrorDetail(await res.text())}`,
        );
      }
      const json = await res.json();
      return json as NoteDataInfo[];
    },
  });
};

export const noteDataInfoInfiniteQueryOptions = (params: {
  patientCognitoSub?: string;
  noteDataId?: number[];
  practiceGroup?: boolean;
  onBehalfOf?: string;
}) => {
  return infiniteQueryOptions({
    queryKey: ["noteDataInfo", params],
    queryFn: async ({ pageParam, signal }) => {
      const url = buildUrlWithParams(
        "/api/notes_secure_data/v1/notes/data/data_info",
        {
          ...params,
          limit: PAGE_SIZE,
          skip: pageParam * PAGE_SIZE,
        },
      );

      const res = await fetchOrchidAPI(url, { signal });
      if (!res.ok) {
        throw new Error(
          `failed to query note data info: ${getErrorDetail(await res.text())}`,
        );
      }
      const json = await res.json();
      return json as NoteDataInfo[];
    },
    initialPageParam: 0,
    getNextPageParam: (lastPage, pages) => {
      const hasMore = lastPage.length === PAGE_SIZE;
      if (!hasMore) {
        return undefined;
      }
      return pages.length;
    },
  });
};

export default noteDataInfoQueryOptions;
